var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 16,
    viewBox: "0 0 44 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4085 0C28.9127 0 30.1291 0.346017 30.8961 0.659404L30.3673 4.00394L30.0156 3.83947C29.312 3.52631 28.3832 3.21336 27.1192 3.24643C25.584 3.24643 24.8955 3.9216 24.8795 4.58078C24.8795 5.30589 25.7124 5.78374 27.0724 6.49242C29.3126 7.59639 30.3518 8.94739 30.3362 10.7105C30.3048 13.9237 27.6486 16 23.5687 16C21.8243 15.9834 20.1441 15.6036 19.2321 15.1757L19.7762 11.6989L20.2882 11.9463C21.5523 12.5236 22.3841 12.7702 23.9365 12.7702C25.056 12.7702 26.2563 12.2919 26.2716 11.2543C26.2716 10.5787 25.7602 10.084 24.2559 9.32603C22.7841 8.58429 20.8162 7.3487 20.8481 5.12412C20.8647 2.10895 23.5687 0 27.4085 0Z",
    fill: "#00579F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9122 15.7692H16.8005L19.2323 0.280762H15.3442L12.9122 15.7692Z",
    fill: "#00579F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8636 0.280762H37.856C36.9285 0.280762 36.2239 0.560641 35.8237 1.56584L30.0481 15.769H34.128C34.128 15.769 34.7997 13.8573 34.944 13.4456H39.9363C40.048 13.9894 40.4003 15.769 40.4003 15.769H44.0005L40.8636 0.280762ZM36.064 10.2822C36.3842 9.39239 37.6164 5.94865 37.6164 5.94865C37.6098 5.962 37.6607 5.81674 37.7363 5.60082C37.848 5.28214 38.0135 4.80951 38.1279 4.46581L38.3997 5.80039C38.3997 5.80039 39.136 9.5078 39.2959 10.2822H36.064Z",
    fill: "#00579F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85645 10.8424L9.66442 0.280762H13.776L7.66422 15.7528H3.55241L0.0644531 2.20817C2.52839 3.5434 4.73633 6.22875 5.44034 8.70037L5.85645 10.8424Z",
    fill: "#00579F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardVisa);
export default __webpack_public_path__ + "static/media/card-visa.a29d5174890aa05db2af26c59593eb53.svg";
export { ForwardRef as ReactComponent };